import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const fetchMerchants = createAsyncThunk(
  "merchants/fetchMerchants",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/all_merchants");
      return response.data.sellers;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const activateMerchant = createAsyncThunk(
  "merchants/activateMerchant",
  async (merchantId, { rejectWithValue }) => {
    try {
      const response = await api.post(`/activate_merchant/${merchantId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deactivateMerchant = createAsyncThunk(
  "merchants/deactivateMerchant",
  async (merchantId, { rejectWithValue }) => {
    try {
      const response = await api.post(`/deactivate_merchant/${merchantId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const merchantReducer = createSlice({
  name: "allmerchants",
  initialState: {
    merchants: [],
    status: "idle",
    success: null,
    error: null,
  },
  reducers: {
    messageClear: (state) => {
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMerchants.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMerchants.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.merchants = action.payload;
      })
      .addCase(fetchMerchants.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      })
      .addCase(activateMerchant.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(activateMerchant.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deactivateMerchant.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(deactivateMerchant.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { messageClear } = merchantReducer.actions;
export default merchantReducer.reducer;
